import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <img src="/images/protego_light.png" alt="P" className="w-6 h-6 brightness-0 invert" />
              </div>
              <div className="text-xl font-bold">
                {t.companyName}
              </div>
            </div>
            <p className="text-gray-400 mb-4">
              {t.companyDescription}
            </p>
          </div>
          
          {/* Links */}
          <div className="md:text-right">
            <h3 className="text-lg font-semibold mb-4">{t.quickLinks}</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-gray-400 hover:text-white transition">{t.aboutUs}</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition">{t.contactUs}</Link></li>
              <li>
                <a href="mailto:info@sanctionscreener.eu" className="text-gray-400 hover:text-white transition">
                  {t.emailLabel} info@sanctionscreener.eu
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 text-gray-400">
          <div className="flex flex-col md:flex-row md:justify-between">
            <div className="mb-4 md:mb-0">
              &copy; {currentYear} {t.companyName}. {t.allRightsReserved}.
            </div>
            <div className="flex flex-wrap gap-x-6 gap-y-2">
              <Link to="/privacy" className="text-gray-400 hover:text-white transition">{t.privacyPolicy}</Link>
              <Link to="/terms" className="text-gray-400 hover:text-white transition">{t.termsOfService.title}</Link>
              <Link to="/gdpr" className="text-gray-400 hover:text-white transition">{t.gdprCompliance}</Link>
            </div>
          </div>
          <div className="mt-4 text-sm">
            {t.euCompliance}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 